import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  margin-left: ${props => props.marginLeft};
  margin-right: ${props => props.marginRight};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  flex-wrap: ${props => props.flexWrap};
  flex-grow: ${props => props.flexGrow};
  flex: ${props => props.flex};
  align-self: ${props => props.alignSelf};
  gap: ${props => props.gap};

  &.sm {
    @media only screen and (max-width: 480px) {
      &.break {
        flex-wrap: wrap;
      }
      &.hide {
        display: none;
      }
    }
  }

  &.md {
    @media only screen and (max-width: 768px) {
      &.break {
        flex-wrap: wrap;
      }
      &.hide {
        display: none;
      }
    }
  }
}

`;
